import * as ngCore from '@angular/core'
import { ComponentStore } from '@ngrx/component-store'
interface State {
  /**
   * Controls the visibility state of the configuration slideout. When true, the
   * configurator UI component is displayed to the user.
   *
   * @default false
   */
  presentConfigurator?: boolean
}

/**
 * Manages layout state for the Summit Archive page
 */
@ngCore.Injectable()
export class Layout extends ComponentStore<State> {
  /** @see {@link State.presentConfigurator}*/
  public readonly presentConfiguratorSg = this.selectSignal(
    state => state.presentConfigurator ?? false,
  )

  constructor() {
    super({ presentConfigurator: false })
  }
}
